import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ReasonCodeData} from "./reason-code.data";

@Injectable()
export class ReasonCodeEntityModel extends EntityModel<ReasonCodeData> {
    constructor(injector: Injector) {
        super(injector, ReasonCodeData);
    }
}
